import type { VerbTypes } from 'modules/core/lib/verbTypes'

import Policy from './Policy'

class ShiftPolicy extends Policy<VerbTypes> {
  checkVerb(verb: VerbTypes): boolean {
    switch (verb) {
      case 'seeShiftHistory':
        return this.permissions.history

      default:
        throw new Error(`Unknown verb ${verb} in policy`)
      // TODO: DRY
    }
  }
}

export default ShiftPolicy
